import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-search",
  "use": "icon-search-usage",
  "viewBox": "0 0 96 96",
  "content": "<symbol viewBox=\"0 0 96 96\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" id=\"icon-search\">\n    <title>icon/基础图标/搜索</title>\n    <g id=\"icon-search_icon/基础图标/搜索\" stroke=\"none\" stroke-width=\"1\" fill=\"none\" fill-rule=\"evenodd\" stroke-linejoin=\"round\">\n        <path d=\"M46.1666667,80.75 C65.2204078,80.75 80.6666667,65.3037412 80.6666667,46.25 C80.6666667,27.1962588 65.2204078,11.75 46.1666667,11.75 C27.1129255,11.75 11.6666667,27.1962588 11.6666667,46.25 C11.6666667,65.3037412 27.1129255,80.75 46.1666667,80.75 Z\" id=\"icon-search_路径备份\" stroke=\"currentColor\" stroke-width=\"10\" />\n        <line x1=\"71.2120833\" y1=\"71.2120833\" x2=\"85\" y2=\"85\" id=\"icon-search_路径备份-2\" stroke=\"currentColor\" stroke-width=\"10\" stroke-linecap=\"square\" />\n    </g>\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg/search.svg
// module id = Bx0U
// module chunks = 3